<template>
  <v-row align="center" justify="center" class="mt-n8 mb-4">
    <v-col cols="12" align="center" justify="center">
      <div class="d-flex justify-center">
        <v-select
          style="max-width: 100px;"
          class="mr-4"
          v-model="selectedPeriod"
          @input="$emit('period', selectedPeriod)"
          label="Period"
          :items="[
            { value: 'days', text: 'Days' },
            { value: 'weeks', text: 'Weeks' },
            { value: 'months', text: 'Months' },
          ]"
        >
        </v-select>
        <v-select
          v-if="reportType == 'SIGNUPS'"
          style="max-width: 150px;"
          class="mr-4"
          v-model="selectedAcquisitionTypes"
          @input="$emit('acquisitiontypes', selectedAcquisitionTypes)"
          label="Acquisition"
          multiple
          :items="[
            { value: 'NEW', text: 'New' },
            { value: 'RETURNING', text: 'Returning' },
            { value: 'CONTINUING', text: 'Continuing' },
            { value: 'UPGRADING', text: 'Upgrading' },
            { value: 'DOWNGRADING', text: 'Downgrading' },
          ]"
        >
        </v-select>

        <v-select
          v-if="reportType == 'CANCELLATIONS'"
          style="max-width: 150px;"
          class="mr-4"
          v-model="selectedEndTypes"
          @input="$emit('endtypes', selectedEndTypes)"
          label="End Type"
          multiple
          :items="[
            { value: 'NO_TRANSITION', text: 'No transition' },
            { value: 'CONTINUED', text: 'Continued' },
            { value: 'RETURNED', text: 'Returned' },
          ]"
        >
        </v-select>
        <v-select
          v-if="reportType == 'CANCELLATIONS'"
          style="max-width: 150px;"
          class="mr-4"
          v-model="selectedTransitionProductTypes"
          @input="$emit('transitionproducttypes', selectedTransitionProductTypes)"
          label="End Transition Product Type"
          multiple
          :items="[
            { value: 'NO_CHANGE', text: 'No Change' },
            { value: 'UPGRADING', text: 'Upgrading' },
            { value: 'DOWNGRADING', text: 'Downgrading' },
          ]"
        >
        </v-select>
        <v-select
          style="max-width: 150px;"
          class="mr-4"
          v-model="selectedCorporateTypes"
          @input="$emit('corporatetypes', selectedCorporateTypes)"
          label="Corporate"
          multiple
          :items="[
            { value: 'CORPORATE', text: 'Corporate' },
            { value: 'CUSTOMER', text: 'Customer' },
          ]"
        >
        </v-select>
        <v-select
          v-if="reportType == 'CANCELLATIONS' || reportType == 'SIGNUPS'"
          style="max-width: 200px;"
          class="mr-4"
          v-model="selectedDiscountCategories"
          @input="$emit('discountcategories', selectedDiscountCategories)"
          label="Discount Category"
          multiple
          item-text="title"
          item-value="id"
          :items="discountCategories"
          :disabled="noDiscounts"
        >
        </v-select>
        <v-checkbox
          v-if="reportType == 'CANCELLATIONS' || reportType == 'SIGNUPS'"
          v-model="noDiscounts"
          @click="
            selectedDiscountCategories = null;
            $emit('nodiscounts', noDiscounts);
          "
          label="No discounts"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { DISCOUNT_CATEGORIES_RETENTION_QUERY } from "@/constants/graphql/billing/billing";

export default {
  name: "SubscriptionFilters",
  props: {
    reportType: {
      type: String,
    },
  },
  data() {
    return {
      selectedAcquisitionTypes: null,
      selectedCorporateTypes: null,
      selectedDiscountCategories: null,
      selectedPeriod: "days",
      noDiscounts: false,
      selectedEndTypes: null,
      selectedTransitionProductTypes: null,
    };
  },

  apollo: {
    discountCategories: {
      query: DISCOUNT_CATEGORIES_RETENTION_QUERY,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
